export { default } from "./Tie";
